// @flow

import BraintreeClient from 'braintree-web/client';
import USBankAccount from 'braintree-web/us-bank-account';
import { useEffect, useState } from 'react';

const useBraintreeBackend = (apiKey: string) => {
  const [client, setClient] = useState(null);

  useEffect(() => {
    const createClient = async () => {
      const braintreeClient = await BraintreeClient.create({
        authorization: apiKey,
      });
      const bankAccount = await USBankAccount.create({
        client: braintreeClient,
      });
      setClient(bankAccount);
    };
    createClient();
  }, [apiKey]);

  return client;
};

export default useBraintreeBackend;
